import React, { useEffect, useRef } from "react";
import projects from "../content/projects";
import { AnimatePresence, motion } from "framer-motion";
import XImage from "../images/x.png";

export const Projects = ({ close }) => {
	const [scroll, setScroll] = React.useState(0);
	const ref = useRef(null);

	useEffect(() => {
		ref.current.addEventListener("scroll", () => {
			setScroll(ref.current.scrollTop);
		});
	}, []);

	return (
		<motion.div
			ref={ref}
			className="bg-black relative h-screen overflow-auto no-scrollbar px-4 w-full max-w-6xl"
			initial={{
				y: "100%",
			}}
			animate={{
				y: "0",
			}}
			transition={{
				duration: 0.6,
			}}
		>
			<motion.div
				className={`flex flex-col items-left text-left w-full sticky top-0 left-0`}
				transition={{ duration: 0.3 }}
			>
				<div className="bg-black p-2">
					<div className="absolute top-4 right-4 lg:right-0">
						<img
							src={XImage}
							className="h-6 cursor-pointer hover:scale-110"
							onClick={close}
							style={{
								filter: "invert(1)",
							}}
						/>
					</div>
					<h1 className="text-3xl font-black blue-color h-12">My projects</h1>
				</div>
				<AnimatePresence>
					{scroll < 1 && (
						<motion.h3
							className="lg:text-xl text-white bg-black p-2 absolute top-12 w-full rounded-b-xl"
							initial={{ opacity: 0, y: -10 }}
							animate={{ opacity: 1, y: 0 }}
							exit={{ opacity: 0, y: -10 }}
							transition={{ duration: 0.3 }}
						>
							These are some of my projects. A combination of web applications,
							desktop applications, and landing pages.
						</motion.h3>
					)}
				</AnimatePresence>
			</motion.div>
			<div className="flex flex-col p-4 gap-4 items-center pt-10" >
				{projects.map((project) => {
					return (
						<div className="bg-white shadow rounded-xl flex flex-col md:flex-row max-w-6xl w-full">
							<img src={project.image} className="w-full md:w-96 rounded-l-xl border-r" />
							<div className="p-4 flex flex-col justify-between">
								<h2 className="text-xl md:text-2xl font-black">
									{project.name}
								</h2>
								<p className="text-lg py-2">{project.description}</p>
								<hr className="w-4/5 m-y-2 bg-black mx-auto" />
								<div className="flex gap-1 justify-between w-full flex-col md:flex-row">
									<div className="flex gap-2 items-center">
										{project.stack.map((stack) => {
											return (
												<div className="flex items-center gap-2">
													<img src={stack.image} className="w-4" />
													<p className="font-bold text-4">{stack.name}</p>
												</div>
											);
										})}
									</div>
									<div className="flex gap-2">
										{project.links.map((link) => {
											return (
												<div className="p-0.5 m-0.5 border rounded-md border-gray-300 hover:bg-gray-100">
													<a
														href={link.url}
														target="_blank"
														className="flex gap-1 md:gap-2 items-center justify-between px-2 cursor-pointer"
														style={{
															cursor: "pointer",
														}}
													>
														<label
															style={{
																pointerEvents: "none",
															}}
														>
															{link.name}
														</label>
														<img src={link.image} className="w-4 h-4" />
													</a>
												</div>
											);
										})}
									</div>
								</div>
							</div>
						</div>
					);
				})}
				<div className="my-10 mx-auto font-bold text-white">Working on more... </div>
			</div>
		</motion.div>
	);
};
